<template>
  <div class="container-popups-simples-form">
    <template v-if="internal_config">
      <sweet-modal ref="config" width="50vw">
        <sweet-modal-tab :title="this.$t('ct-email')" id="email">
          <div class="form-group">
            <label for="simple-form-email">{{ $t('ct-email-receiver') }}</label>
            <input type="email" placeholder="example@example.com" id="simple-form-email" class="form-control"
                   @change="validateEmail"
                   @keydown="errors.clear('receiver')"
                   :class="{ 'is-invalid': errors.has('receiver')}"
                   v-model="internal_config.receiver"/>
            <span
              v-if="errors.has('receiver')"
              class="invalid-feedback"
              v-text="errors.get('receiver')"
            ></span>
          </div>

          <div class="form-group">
            <label for="simple-form-subject">{{ $t('ct-subject') }}</label>
            <input type="text" :placeholder="$t('ct-subject')" id="simple-form-subject" class="form-control"
                   v-model="internal_config.subject"/>
          </div>

          <div class="form-group">
            <label for="simple-form-redirect">{{ $t('ct-redirect-url') }}</label>
            <input type="url" :placeholder="$t('ct-redirect')" class="form-control" id="simple-form-redirect"
                   v-model="internal_config.redirect"/>
          </div>

          <p class="my-3">{{ $t('ct-success-message-and-errors') }}</p>

          <div class="form-group">
            <label for="simple-form-successMessage">{{ $t('ct-success-message') }}</label>
            <input type="text" class="form-control" id="simple-form-successMessage"
                   v-model="internal_config.successMessage"/>
          </div>

          <div class="form-group">
            <label for="simple-form-isRequiredMessage">{{ $t('ct-is-required-message') }}</label>
            <input type="text" class="form-control" id="simple-form-isRequiredMessage"
                   v-model="internal_config.isRequiredMessage"/>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab :title="this.$t('ct-fields')" id="fields">
          <span class="table-caption">{{ $t('ct-fields') }}</span>
          <div class="table-contact-form">
            <table class="table">
              <thead>
              <th scope="col">{{ $t('ct-type') }}</th>
              <th scope="col">{{ $t('ct-label') }}</th>
              <th scope="col">{{ $t('ct-tag') }}</th>
              <th scope="col">
                <button class="btn btn-primary float-right text-uppercase" @click="$refs.addField.open()">
                  <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
                  {{ $t('ct-add-field') }}
                </button>
              </th>
              </thead>
              <tbody>
              <template v-if="internal_config.fields.length">
                <tr
                  v-for="(field,index) in internal_config.fields"
                  :class="{'animated flash': internal_config.fieldAnimated}"
                  @animationend="internal_config.fieldAnimated = false"
                >
                  <td>{{ field.field }}</td>
                  <td>{{ field.label }}</td>
                  <td>{{ field.tag }}</td>
                  <td class="text-right">

                    <i class="mdi mdi-chevron-down text-secondary"
                       v-tooltip="{content:$t('ct-option-down'),  class: 'tooltip-custom'}"
                       @click="changePosition(index, index+1)"
                    />

                    <i class="mdi mdi-chevron-up text-secondary"
                       v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
                       @click="changePosition(index, index-1)"
                    />

                    <i class="mdi mdi-pencil text-primary"
                       v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
                       @click="editField(field, index)"
                    />

                    <i class="ct-icon-trash text-danger"
                       v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                       @click.prevent="removeOption(index, 0)"
                    />
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="4" class="text-center">
                  {{ $t('ct-fields-empty') }}
                </td>
              </tr>
              </tbody>
            </table>

          </div>
          <small class="text-for-help">{{ $t('ct-hint-email-reply-to') }}</small>
        </sweet-modal-tab>

        <sweet-modal-tab :title="this.$t('ct-action')" id="action">
          <div class="form-group">
            <label for="simple-form-action">{{ $t('ct-action-url') }}</label>
            <input type="url" placeholder="action" id="simple-form-action" class="form-control"
                   v-model="internal_config.action"/>
            <small class="text-for-help">
              <a :href="`${this.officeUrl}/us/office/franchise-system?opentool=linkMagicFunnel`"
                 target="_blank">{{ $t('ct-link-magic-funnel-link') }}</a>
              {{ $t('ct-link-magic-funnel') }}
            </small>
            <div class="ba-alert ba-info">
              <svg style="flex-shrink: 0;" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4651_295)">
                <path d="M12.5 0C19.3925 0 25 5.6075 25 12.5C25 14.4913 24.5188 16.4644 23.605 18.2325L24.9419 23.0181C25.0931 23.56 24.94 24.1444 24.5419 24.5425C24.245 24.8394 23.845 25 23.435 25C23.295 25 23.1544 24.9813 23.0163 24.9425L18.2281 23.6056C16.4613 24.5188 14.4894 25 12.5 25C5.6075 25 0 19.3925 0 12.5C0 5.6075 5.6075 0 12.5 0ZM13.4375 6.5625C13.4375 6.045 13.0181 5.625 12.5 5.625C11.9819 5.625 11.5625 6.045 11.5625 6.5625V14.0625C11.5625 14.58 11.9819 15 12.5 15C13.0181 15 13.4375 14.58 13.4375 14.0625V6.5625ZM12.5 19.375C13.1906 19.375 13.75 18.8156 13.75 18.125C13.75 17.4344 13.1906 16.875 12.5 16.875C11.8094 16.875 11.25 17.4344 11.25 18.125C11.25 18.8156 11.8094 19.375 12.5 19.375Z" fill="#0072E1"/>
                </g>
                <defs>
                <clipPath id="clip0_4651_295">
                <rect width="25" height="25" fill="white" transform="matrix(-1 0 0 1 25 0)"/>
                </clipPath>
                </defs>
              </svg>
              <span>{{ $t('ct-form-action-info-alert') }}</span></div>
          </div>
        </sweet-modal-tab>

        <button
          slot="button"
          class="btn btn-outline-light"
          @click="close('config')"
        >{{ $t('ct-cancel') }}
        </button>
        <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{$t('ct-save')}}</button>
      </sweet-modal>

      <add-field ref="addField" @openPopupField="openPopupField" @close="close"></add-field>

      <sweet-modal ref="text" width="40vw" :title="$t('ct-config-field')">
        <div class="form-row">
          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-tag') }}</label>
            <input type="text" v-model="internal_config.newField.tag" @keydown="errors.clear('newField.tag')"
                   :class="{ 'is-invalid': errors.has('newField.tag')}"
                   class="form-control" name="tag"/>
            <span
              v-if="errors.has('newField.tag')"
              class="invalid-feedback"
              v-text="errors.get('newField.tag')"
            ></span>
          </div>
          <div class="form-group col-12 col-sm-9">
            <label>{{ $t('ct-label') }}</label>
            <input type="text" v-model="internal_config.newField.label" :class="{ 'is-invalid': errors.has('newField.label')}" @keydown="errors.clear('newField.label')" class="form-control" name="label"/>
            <span
              v-if="errors.has('newField.label')"
              class="invalid-feedback"
              v-text="errors.get('newField.label')"
            ></span>
          </div>

          <div class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-default-value') }}</label>
            <input type="text" v-model="internal_config.newField.default_value" class="form-control"
                   name="default_value"/>
          </div>

          <div class="form-group col-12 col-sm-7">
            <label>{{ $t('ct-help-text') }}</label>
            <input type="text" class="form-control" name="help_text" v-model="internal_config.newField.help_text"/>
          </div>

          <div class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-required') }}</label>
            <select v-model="internal_config.newField.required" name="required" class="form-control"
                    @change="verifyRequired">
              <option value="yes">{{ $t('ct-yes') }}</option>
              <option value="no">{{ $t('ct-no') }}</option>
            </select>
          </div>

          <div class="form-group col-12 col-sm-7" ref="visibilyField">
            <label>{{ $t('ct-visibility') }}</label>
            <select v-model="internal_config.newField.visibility" name="visibility" class="form-control">
              <option value="visible">{{ $t('ct-visible') }}</option>
              <option value="hidden">{{ $t('ct-hidden') }}</option>
            </select>
          </div>

          <div class="form-group col-12 col-sm-7" ref="validationField">
            <label>{{ $t('ct-custom-validation') }}</label>
            <select v-model="internal_config.newField.validation" name="validation" class="form-control">
              <option value="">{{ $t('ct-none') }}</option>
              <option value="fullname">{{ $t('ct-full-name') }}</option>
            </select>
          </div>

          <div class="form-group col-12 d-flex justify-content-between align-items-end"
               v-if="typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.selected">

            <div class="icon-settings-content-align flex-1"
                 v-show="typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon && typeof internal_config.newField.icon.selected != 'undefined'">
              <div class="form-group" v-if="internal_config.newField.icon">
                <label class="text__simple-text"> {{ $t('ct-icon-settings') }} - {{ $t('ct-align') }}</label>
                <div class="btn-icon-group">
                  <div
                    class="btn-icon-align"
                    :class="{'active' : typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.position === 'left'}"
                    @click.prevent="changeIconPosition('left')"
                  >
                    <i :class="this.$addIconPrefix(internal_config.newField.icon.selected)"/>
                    <span>{{ $t('ct-left') }}</span>
                    <i class="input-radio-icon"/>
                  </div>
                  <div
                    class="btn-icon-align"
                    :class="{'active' : typeof internal_config.newField.icon != 'undefined' && internal_config.newField.icon.position === 'right'}"
                    @click.prevent="changeIconPosition('right')"
                  >
                    <span>{{ $t('ct-right') }}</span>
                    <i :class="this.$addIconPrefix(internal_config.newField.icon.selected)"/>
                    <i class="input-radio-icon"/>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-danger btn-lg px-4"
                    @click="removeIcon"
            >
              <i class="svg-icon svgi-delete svgi-light m-0"
                 v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"/>
            </button>
          </div>
        </div>

        <button slot="button" class="btn btn-primary ml-0 float-left"
                v-if="typeof internal_config.newField.icon !== 'undefined' && internal_config.newField.icon.selected"
                @click="selectIcon"><i class="svg-icon svgi-add-page"></i>{{ $t('ct-change-icon') }}
        </button>
        <button slot="button" class="btn btn-primary ml-0 float-left" v-else @click="selectIcon"><i
          class="svg-icon svgi-add-page"></i>{{ $t('ct-add-icon') }}
        </button>

        <button slot="button" class="btn btn-outline-light" @click="close('text')">{{ $t('ct-cancel') }}</button>
        <button slot="button" class="btn btn-success" @click="genField('text')"><i
          class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal ref="select" :title="$t('ct-config-field')">
        <div class="form-row">
          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-tag') }}</label>
            <input type="text"
                   v-model="internal_config.newField.tag"
                   :class="{ 'is-invalid': errors.has('newField.tag')}"
                   @keydown="errors.clear('newField.tag')"
                   class="form-control" name="tag"/>
            <span
              v-if="errors.has('newField.tag')"
              class="invalid-feedback"
              v-text="errors.get('newField.tag')"
            ></span>
          </div>
          <div class="form-group col-12 col-sm-9">
            <label>{{ $t('ct-label') }}</label>
            <input type="text"
                   v-model="internal_config.newField.label"
                   :class="{ 'is-invalid': errors.has('newField.label')}"
                   @keydown="errors.clear('newField.label')"
                   class="form-control" name="label"/>
            <span
              v-if="errors.has('newField.label')"
              class="invalid-feedback"
              v-text="errors.get('newField.label')"
            ></span>
          </div>

          <div class="form-group col-12 col-sm-6">
            <label>{{ $t('ct-help-text') }}</label>
            <input type="text" class="form-control" name="help_text" v-model="internal_config.newField.help_text"/>
          </div>

          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-required') }}</label>
            <select v-model="internal_config.newField.required" name="required" class="form-control"
                    @change="verifyRequired">
              <option value="yes">{{ $t('ct-yes') }}</option>
              <option value="no">{{ $t('ct-no') }}</option>
            </select>
          </div>

          <div class="form-group col-12 col-sm-3" ref="visibilyFieldOption">
            <label>{{ $t('ct-visibility') }}</label>
            <select v-model="internal_config.newField.visibility" name="visibility" class="form-control">
              <option value="visible">{{ $t('ct-visible') }}</option>
              <option value="hidden">{{ $t('ct-hidden') }}</option>
            </select>
          </div>
        </div>

        <span class="table-caption">{{ $t('ct-resource-components') }}</span>

        <div class="table-contact-form">
          <table class="table">
            <thead>
            <th>{{ $t('ct-value') }}</th>
            <th>{{ $t('ct-name') }}</th>
            <th class="text-center">{{ $t('ct-default-option') }}</th>
            <th class="text-right">
              <button
                class="btn m-0 p-0"
                v-if="internal_config.newField.default_value"
                @click="internal_config.newField.default_value = ''"
                v-tooltip="{content:$t('ct-delete-default-value'),  class: 'tooltip-custom'}">
                <i class="ct-icon-trash text-dark"/>
              </button>
              <button class="btn btn-primary ml-1" @click="openOptionPopup">
                <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
                {{ $t('ct-add-option') }}
              </button>
            </th>
            </thead>
            <tbody>
            <template v-if="internal_config.newField.options.length">
              <tr v-for="(option,index) in internal_config.newField.options">
                <td>{{ option.value }}</td>
                <td>{{ option.name }}</td>
                <td class="text-center">
                  <div class="form-check">
                    <input class="form-check-input position-static" type="radio" name="defaultOption"
                           :id="'defaultOption' + index" :value="option.value"
                           v-model="internal_config.newField.default_value">
                  </div>
                </td>
                <td class="text-right">
                  <i class="ct-icon-trash text-danger"
                     v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                     @click="removeOption(index,1)"
                  />
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="4" class="text-center">
                {{ $t('ct-options-empty') }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <button slot="button" class="btn btn-outline-light" @click="close('select')">{{ $t('ct-cancel') }}</button>
        <button slot="button" class="btn btn-success" @click="genField('select')"><i
          class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal ref="option" width="40vw" :title="$t('ct-config-field')">
        <div class="form-row">
          <div class="form-group col-4">
            <label>{{ $t('ct-value') }}</label>
            <input type="text" class="form-control" name="value" ref="form_option_value"/>
          </div>

          <div class="form-group col-8">
            <label>{{ $t('ct-name') }}</label>
            <input type="text" class="form-control" name="name" ref="form_option_name"/>
          </div>
        </div>

        <button slot="button" class="btn btn-outline-light" @click="close('option')">{{ $t('ct-cancel') }}</button>
        <button slot="button" class="btn btn-success" @click="addOption"><i
          class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </sweet-modal>
    </template>
  </div>
</template>

<script>

import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
import CheckFields from '../Fields/CheckFields';
import SelectFields from '../Fields/SelectFields';
import TextFields from '../Fields/Text';
import DateFields from '../Fields/DateFields';
import Errors from "../../../../../js/base/Errors";
import AddField from "../ConfigModals/AddField.vue";

export default {
  name: 'ConfigModals',
  components: {
    AddField,
    SweetModal,
    SweetModalTab,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields
  },
  data() {
    return {
      internal_config: false,
      config_current: {
        internal: false,
        field: false,
      },
      callback: false,
      errors: new Errors()
    };
  },
  computed: {
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
    }
  },
  methods: {
    init(config, callback = false) {
      this.internal_config = config;
      this.callback = callback;
    },
    open(modal) {
      if(modal === 'config') {
        this.config_current['internal'] = JSON.parse(JSON.stringify(this.internal_config))
      }

      if (this.$refs[modal]) {
        this.$refs[modal].open()
      }
    },

    close(modal){

      if(modal === 'config') {
        this.callback(this.config_current['internal']);
        this.reload();
      }

      if( modal === 'text' || modal === 'select'){
        var field = {...this.config_current['field']};
        delete field.index;
        this.internal_config.fields[this.config_current['field'].index] = {...field}
      }

      if (this.callback && typeof this.callback === 'function') {
        this.$refs[modal].close();
      }

      this.errors.clear();
    },

    save() {
      if(!this.validate()){
        return;
      }

      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.internal_config);
        this.$refs['config'].close();
      }
    },

    validate(){

      if (this.errors.any()) {
        this.$snotify.warning(this.$t('ct-check-configs'));
        return false;
      }

      if(this.internal_config.receiver.length === 0 && this.internal_config.action.length === 0){
        this.$snotify.warning(this.$t('ct-config-action-receiver'));

        return false;
      }

      else if(this.internal_config.receiver.length > 0 && this.internal_config.action.length === 0) {
        this.validateEmail();
      }

      return true;
    },

    validateEmail(){
      let regexEmail = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

      if (this.internal_config.receiver.length === 0) {
        this.errors.add('receiver', 'validation-required');
      }

      if (this.internal_config.receiver.length > 0 && !regexEmail.exec(this.internal_config.receiver)) {
        this.errors.add('receiver', 'invalid-email-regex');
      }

    },

    editField(field, index) {
      this.internal_config.newField = field;

      this.internal_config.newField.status = 'edit';

      if (typeof field.icon === 'undefined') {
        this.internal_config.newField.icon = {'selected': null, 'position': null};
      }

      this.verifyRequired();

      this.config_current['field'] = {...field, index: index};

      if (
        this.internal_config.newField.field === 'datetime' ||
        this.internal_config.newField.field === 'date' ||
        this.internal_config.newField.field === 'text' ||
        this.internal_config.newField.field === 'textarea'
      ) {
        this.$refs['text'].open();
      } else {
        this.$refs['select'].open();
      }
    },

    animateField() {
      this.internal_config.fieldAnimated = true;
    },

    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.fields.length || newIndex < 0) {
        return;
      }

      this.animateField();
      this.internal_config.fields.splice(
        newIndex,
        0,
        this.internal_config.fields.splice(index, 1)[0]
      );
    },

    openOptionPopup() {
      this.$refs.form_option_name.value = '';
      this.$refs.form_option_value.value = '';
      this.$refs.option.open();
    },

    reloadConfig() {
      let config = this.internal_config;
      this.internal_config = Object.assign({}, this.internal_config, config);
    },

    selectIcon() {
      let _self = this;
      let selectIcon;

      window.vm.$root.$emit('showIconList', function (icon) {
        selectIcon = {'selected': icon, 'position': 'left'};
        _self.internal_config.newField.icon = selectIcon;

        let config = _self.internal_config;
        _self.internal_config = Object.assign({}, _self.internal_config, config);
      });
    },
    removeIcon() {
      this.internal_config.newField.icon = {'selected': false, 'position': 'left'};
      this.reloadConfig();
    },
    changeIconPosition(value) {
      this.internal_config.newField.icon.position = value;
      this.reloadConfig();
    },

    verifyRequired() {
      if (this.internal_config.newField.required == 'no') {
        this.$refs.visibilyField.style.display = 'block';
        this.$refs.visibilyFieldOption.style.display = 'block';
      } else {
        this.$refs.visibilyField.style.display = 'none';
        this.$refs.visibilyFieldOption.style.display = 'none';
      }
    },

    genField(val) {

      if (typeof this.internal_config.newField.tag === "undefined" || this.internal_config.newField.tag.length === 0) {
        this.errors.add('tag', 'validation-required', 'newField');
      }

      if(this.errors.any())
        return;

      if (this.internal_config.newField.status === 'add') {
        this.internal_config.fields.push(
          Object.assign({}, this.internal_config.newField)
        );
      }
      this.$refs[val].close();
      this.$refs.addField.close();
    },

    reload() {
      let config = this.internal_config;
      this.internal_config = Object.assign({}, this.internal_config, config);
    },

    addOption() {
      let obj = {
        name: this.$refs.form_option_name.value,
        value: this.$refs.form_option_value.value
      };
      this.internal_config.newField.options.push(Object.assign({}, obj));
      this.$refs.option.close();

      this.reload();
    },

    removeOption(index, level) {
      if (level === 0) {
        this.internal_config.fields.splice(index, 1);
      } else {
        this.internal_config.newField.options.splice(index, 1);
      }

      this.reload();
    },

    openPopupField(val, field) {
      this.internal_config.newField = false;
      this.internal_config.newField = {};

      this.internal_config.newField.status = 'add';
      this.internal_config.newField.field = field;
      this.internal_config.newField.label = '';
      this.internal_config.newField.validation = '';
      this.internal_config.newField.default_value = '';
      this.internal_config.newField.visibility = 'visible';
      this.internal_config.newField.required = 'no';
      this.internal_config.newField.options = [];
      this.internal_config.newField.help_text = '';
      this.internal_config.newField.icon = {'selected': null, 'position': null};

      this.verifyRequired();

      this.$refs[val].open();
    }
  }
};
</script>

<style lang="scss" scoped>

.icon-settings-content-align {
  display: flex;

  &__selected {
    display: flex;
    flex-direction: column;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-group:last-child {
    flex: 1;
  }

  .btn-icon-group {
    display: flex;
    padding-top: 3px;

    .btn-icon-align {
      position: relative;
      flex: 1;
      background: #FAFBFC;
      border: 1px dashed #B0BFCE;
      border-radius: 5px;

      text-align: left;
      font-size: 14px;

      transition: .4s;

      padding: 10px 20px;

      &:hover, &.active, &:focus {
        border: 1px dashed #0080FC;
        outline: none;
      }

      i {
        margin: 0 5px;

        font-size: 18px;
        color: #0795ff;
      }

      .input-radio-icon {
        top: 8px;
        right: 5px;

        width: 15px;
        height: 15px;
      }
    }

    .btn-icon-align + .btn-icon-align {
      margin-left: 20px;
    }
  }
}

.container-field-add {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 15px;

  margin-left: -15px;
  margin-right: -15px;

  .btn {
    font: normal normal 800 14px/16px Muli;
    text-transform: uppercase;

    height: 45px;
  }
}

.btn-dashed-choose {
  font-family: 'Lato', sans-serif !important;
  font-size: 14px !important;
  text-align: left;
  color: #656565 !important;

  height: 47px;

  background: #FAFBFC;
  border: 1px dashed #B0BFCE;
  border-radius: 3px;

  position: relative;

  &:hover, &.active {
    border-color: #0080FC;
  }

  i {
    right: 0;
  }
}
.ba-alert.ba-info {
  background-color: #ECF5FF80;
  border-radius: 8px;
  padding: 20px;
  gap: 20px;
  font-family: Montserrat;
  display: flex;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/SimpleForm/ConfigModals.vue